import React from 'react';
import { Menu } from 'antd';
import styles from './app_menu.less';

const { Item } = Menu;

function AppMenu(props) {
  const defaultSelectedKeys = props.defaultSelectedKeys || [];
  const defaultOpenKeys = props.defaultOpenKeys || [];

  const menuOptions = {
    defaultSelectedKeys: defaultSelectedKeys,
    defaultOpenKeys: defaultOpenKeys,
    mode: 'vertical',
    theme: 'dark',
    selectable: false
  };

  return (
    <Menu {...menuOptions} className="app-menu">
      <Item key="app" style={{ paddingLeft: '40px' }}>
        <span>应用管理</span>
      </Item>
    </Menu>
  )

}

export default AppMenu;